import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconBedSvg } from "./IconBedSvg.mjs";
const IconBed = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconBedSvg, ...iconProps });
};
export {
  IconBed
};
